var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCongratsRibbon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "49px",
    viewBox: "0 0 49 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "congrats_ribbon@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IRA-tables",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1551.000000, -4078.000000)",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18-Copy",
    transform: "translate(1552.000000, 4079.000000)",
    stroke: "#05C3DE",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "congrats_ribbon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(0.440000, 0.440000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1",
    points: "7.68751012 26.88 0 40.4379195 7.76908551 38.8258965 10.0998112 46.08 17.28 35.3270005"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    points: "39.3343069 27.84 46.08 39.59236 38.3218711 38.7814049 35.9346948 46.08 29.76 35.4775742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.24,18.24 C42.24,28.3140313 34.0732383,36.48 24,36.48 C13.9259687,36.48 5.76,28.3140313 5.76,18.24 C5.76,8.16676174 13.9259687,0 24,0 C34.0732383,0 42.24,8.16676174 42.24,18.24 Z",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-7",
    points: "24 9.6 27.1418182 15.8836364 32.64 15.8836364 27.9272727 19.8109091 30.2836364 26.88 24 22.9425164 17.7163636 26.88 20.0727273 19.8109091 15.36 15.8836364 20.8581818 15.8836364"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongratsRibbon);
export default __webpack_public_path__ + "static/media/congrats_ribbon.8cdb0d7e609ac0c254a85c53422690cf.svg";
export { ForwardRef as ReactComponent };